<template>
  <v-dialog v-model="dialog" persistent max-width="400" @keydown.esc="onCancel">
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text v-html="text"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="onCancel">Cancel</v-btn>
        <v-btn color="primary" flat @click.native="onOk">{{ actionButton }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import bus from '../bus';

  export default {

    data() {
      return {
        dialog: false,
        title: '',
        text: '',
        actionButton: 'Ok',
        action: function() {}
      };
    },

    created() {
      bus.$on('confirmation-dialog-show', message => {
        this.title = message.title;
        this.text = this.nl2br(message.text);
        this.action = message.action;
        this.actionButton = message.actionButton;
        this.dialog = true;
      });
    },

    methods: {

      nl2br(str) {
        const breakTag = '<br />';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
      },

      onCancel() {
        this.dialog = false;
      },

      onOk() {
        this.action();
        this.dialog = false;
      }

    }
  };
</script>


// WEBPACK FOOTER //
// src/components/ConfirmationDialog.vue